<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>礼包管理</el-breadcrumb-item>
      <el-breadcrumb-item>红包雨</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="main-border">
      <el-form  ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="红包雨ID" prop="addUserId">
          <el-input size="small" v-model="form.redId" disabled></el-input>
        </el-form-item>
        <el-form-item label="红包雨金额" prop="num">
          <el-input size="small" v-model="form.redAmount" disabled></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" :loading="submitting">开启红包雨</el-button>
        </el-form-item>
      </el-form>

    </div>
  </div>
</template>

<script>
import {getCanStartRedPool,startRedPool} from "@/api/request";

export default {
  name: "RedPool",
  inject: ['reload'],
  data() {
    return {
      submitting: false,
      envelopesList: [],
      form: {
        redId: '',
        redAmount: '',
      },
      rules: {}
    }
  },
  mounted() {
    getCanStartRedPool().then(res => {
          if (res.data.success) {
            this.form.redId = res.data.data.red_id;
            this.form.redAmount = res.data.data.money;
          } else {
            this.$message.error(res.data.error.message);
          }
        });
  },
  methods: {
    onSubmit() {
      this.$confirm('此操作将开启红包雨, 是否继续?', {

        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = this.form
        startRedPool(params).then(res => {
              if (res.data.success) {
                this.$message.success('红包发放成功！');
                this.submitting = false;
                this.reload();
              } else {
                this.$message.error(res.data.error.message);
                this.submitting = false;
                this.reload();
              }
              this.submitting = false;
            }
        );
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
        this.submitting = false;
      })
    },
  }
}
</script>

<style scoped>
/deep/ .el-input {
  width: 250px !important;
  min-width: 200px;
}

/deep/ .el-input__inner {
  border-radius: 2px !important;
  border: 1px solid #aaaaac !important;
}

/deep/ .el-form-item__label {
  font-weight: 600;
  font-size: 13px;
}

.main-button {
  font-weight: 700;
  width: 120px;
}

.el-button {
  font-weight: 700;
  width: 180px;
}
</style>